<template>

	<div class="image-gallery">

		<div class="slider-wrapper image-gallery__slider">

			<swiper
				:options="swiperOptions"
				ref="swiperTop"
			>
				<swiper-slide
					v-for="(image, index) in images"
					v-bind:key="index"
				>

					<div class="image-gallery__slider__slide">
						<img
							style="width:100%;"
							class="image lazy"
							v-lazy:src="image.image_url"
							:src="image.image_url"
						/>
					</div>

				</swiper-slide>

			</swiper>

			<ul class="image-gallery__slider__thumbs">
				<li
					v-for="(image, index) in images"
					v-bind:key="index"
				>
					<div
						v-on:click.prevent="didSelectThumbnailAtIndex(index)"
						class="image"
						v-lazy:background-image="image.image_url"
						:key="image.image_url"
					></div>
				</li>
			</ul>

		</div>

	</div>

</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
	data() {
		return {
			swiperOptions: {
				pagination: {
					el: '.image-gallery-slider .swiper-pagination',
					type: 'bullets',
					clickable: true,
				},
				effect: 'slide',
				autoplay: { delay: 5000 },
				speed: 1000,
				autoHeight: true,
				keyboard: true,
				loop: true,
				slidesPerView: 1,
				spaceBetween: 0,
				runCallbacksOnInit: true,
				navigation: {
					nextEl: '.image-gallery-slider .swiper-button-next',
					prevEl: '.image-gallery-slider .swiper-button-prev',
				},
			},
		};
	},

	props: {
		images: {},
	},

	computed: {
		swiperTop() {
			return this.$refs.swiperTop.swiper;
		},
	},

	watch: {},

	methods: {
		didSelectThumbnailAtIndex: function (index) {
			this.swiperTop.slideTo(index + 1, 350, false);
		},
	},

	components: {
		swiper,
		swiperSlide,
	},

	created() {},

	destroyed() {},

	mounted() {
		var self = this; //,
		//swiperTop = this.$refs.swiperTop.swiper,
		//swiperThumbs = this.$refs.swiperThumbs.swiper;

		self.swiperTop.controller.control = self.swiperThumbs;

		setTimeout(function () {
			// Triggering an udpate after 0.5s to make sure the views are properly spaced according to
			// the current window size. This shouldn't really be necessary but occasionally I have found
			// the rendering is slightly off until the window is resized, so just making sure.
			self.swiperTop.update();
		}, 500);
	},
};
</script>



<style lang="scss" scoped>
@import '../../styles/common/variables';

.image-gallery__slider__slide {
	position: relative;

	.image {
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center center;

		&::after {
			content: '';
			display: block;
			padding-bottom: 56.25%;
		}

		&.lazy[lazy='error'] {
			background-size: 100px;
		}
	}
}

.image-gallery__slider__thumbs {
	list-style: none;
	padding: 0;
	margin: 0;
	margin-top: $spacer;
	display: flex;
	flex-wrap: wrap;
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: $spacer;

	li {
		position: relative;

		img {
			width: 100%;
		}

		.image {
			display: block;
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center center;
			max-height: 170px;

			&:hover {
				cursor: pointer;
				opacity: 0.8;
			}

			&::after {
				content: '';
				display: block;
				padding-bottom: 100%;
			}

			&.lazy[lazy='error'] {
				background-size: 100px;
			}
		}
	}
}
</style>







// WEBPACK FOOTER //
// resources/assets/scripts/vue/ImageGallery.vue